// **************
// p-cardferiado.jsx
// autor: Walcledson de Paula/IA
// data: 08/11/24 / 22:58h
// *************

import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import apiaxios from '../../../../Services/apiaxios.js';
import { decrypt } from '../../../../Services/cryptoUtils'
import handleApiError from '../../../../Services/apiErrorHandler';
import { AutoLogout } from '../../../../Services/autologout.js';

import './p-cardferiado.jsx';

const CardFeriado = ({ id_empresa, operacao, feriado, openDock, closeDock }) => {
    const [id_feriado, setId_feriado] = useState(0);
    const [descricao, setDescricao] = useState('');
    const [feriado_data, setFeriado_data] = useState('');
    const [loading, setLoading] = useState(false);

    // verifica tokens
    // const tokenASW = localStorage.getItem("tokenasw");
    const tokenASW = decrypt(localStorage.getItem('tokenasw'));
    useEffect(() => {
        const tokenlg = localStorage.getItem("tokenlg");
       
        if (!tokenASW || !tokenlg) {
            AutoLogout();
        }
    }, []);

    useEffect(() => {
        if (operacao === 'edit' && feriado) {
            setId_feriado(feriado.ID_FERIADO);
            setDescricao(feriado.DESCRICAO);
            setFeriado_data(feriado.DIAMES);
        } else {
            setDescricao('');
            setFeriado_data('');
        }
    }, [operacao, feriado]);

    const handleSubmit = () => {
        // Lógica de submissão
    };

    // Função para salvar os dados (alterados ou novos)
    const handleSalvarDados = () => {
        // alert('salvar dados');
        // console.log('validateForm ', validateForm);
        if (validateForm()) {            
            // console.log('dentro de validateform');
            closeDock();
            if (operacao === 'add') {
                // closeDock();
                Swal.fire({
                    title: 'Confirmação',
                    text: 'Confirma os dados do novo Feriado ?',
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, salvar!',
                    cancelButtonText: 'Cancelar'
                }).then((result) => {
                    if (result.isConfirmed) {
                        fetchSalvarDados();
                    }
                    // openDock();
                });
            } else {
                // closeDock();
                Swal.fire({
                    title: 'Confirmação',
                    text: "Confirma a alteração dos dados do Feriado " + id_feriado + ' ?',
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, alterar!',
                    cancelButtonText: 'Cancelar'
                }).then((result) => {
                    if (result.isConfirmed) {
                        fetchSalvarDados();
                    }
                    // openDock();
                });
        
            }
        }
    };

    // const formatForServer = (value) => {
    //     // Remove caracteres não numéricos e formata a entrada
    //     let formattedValue = handleTimeInput(value);
    
    //     // Divide a string em horas e minutos
    //     const [hoursStr, minutesStr] = formattedValue.split(':');
    //     let hours = parseInt(hoursStr, 10) || 0;
    //     let minutes = parseInt(minutesStr, 10) || 0;
    
    //     // Converte para minutos totais e depois ajusta
    //     let totalMinutes = (hours * 60) + minutes;
    
    //     // Ajusta para horas e minutos novamente
    //     const adjustedHours = Math.floor(totalMinutes / 60);
    //     const adjustedMinutes = totalMinutes % 60;
    
    //     return `${String(adjustedHours).padStart(2, '0')}:${String(adjustedMinutes).padStart(2, '0')}`;
    // };
    
    const fetchSalvarDados = async () => {
        setLoading(true);
        if (operacao === 'add') {
            // Formata a duração para o formato esperado pelo servidor
            // const formattedDuracao = formatForServer(duracao);
            try {
                // console.log('id_usuario ', id_empresa);
                // console.log('token ', tokenASW);
                closeDock();
                const response = await apiaxios.post('servico/FeriadoWeb', 
                    {
                        id_empresa,
                        feriado_descricao: descricao,
                        feriado_data
                    },
                    {
                        params: {
                            'id_usuario': id_empresa,  // Enviando id_usuario no cabeçalho
                            'token': tokenASW  // Enviando token JWT no cabeçalho
                        }
                    }
                );

                if (response.status === 201) {
                    const data = response.data;
                    if (data.retorno === 'OK') {
                        Swal.fire('Informação', 'Feriado Cadastro com sucesso!', 'success');
                        // closeDock();
                    } else {
                        Swal.fire('Erro', data.retorno, 'error');
                        openDock();
                    }
                } else { 
                    if (response.status !== 201) {
                        const data = response.data;
                        Swal.fire('Erro', data.retorno, 'error');
                    } else {
                        // closeDock();
                        Swal.fire('Erro', 'Falha ao salvar dados do feriado. Tente novamente mais tarde.', 'error');
                        openDock();
                    }
                }
            } catch (error) {
                handleApiError(error);
            } finally {
                setLoading(false);
            }
        } else {
            try {
                const response = await apiaxios.put('/servico/FeriadoWeb', 
                    {
                        id_feriado,
                        id_empresa,
                        feriado_descricao: descricao,
                        feriado_data
                    },
                    {
                        params: {
                            'id_usuario': id_empresa,  // Enviando id_usuario no cabeçalho
                            'token': tokenASW  // Enviando token JWT no cabeçalho
                        }
                    }
                );
                if (response.status === 200) {
                    const data = response.data;
                    if (data.retorno === 'OK') {
                        Swal.fire('Informação', '"Feriado" alterado com sucesso!', 'success');
                        // closeDock();
                    } else {
                        Swal.fire('Erro', data.retorno, 'error');
                        openDock();
                    }
                } else { if (response.status !== 200) {
                    const data = response.data;
                    Swal.fire('Erro', data.retorno, 'error');
                    } else {
                        Swal.fire('Erro', 'Falha ao tentar salvar alterações do "Feriado". Tente novamente mais tarde.', 'error');
                        openDock();
                    }
                }
            } catch (error) {
                handleApiError(error);
            } finally {
                setLoading(false);
            }
        }
    };    

    // Função para aplicar máscara de DD/MM
    const handleTimeInput = (value) => {
        value = value.replace(/\D/g, ''); // Remove caracteres não numéricos
        if (value.length > 4) {
            value = value.substring(0, 4); // Limita a 4 caracteres numéricos
        }
        value = value.replace(/(\d)(\d{2})$/, '$1/$2'); // Adiciona a vírgula antes dos últimos dois dígitos
        // value = value.replace(/(?=(\d{2})+(\D))\B/g, ':'); // Adiciona pontos a cada milhar
        return value;
    };

    // // Função para remover formatação antes de enviar ao servidor
    // const parseCurrency = (value) => {
    //     if (typeof value !== 'string') {
    //         // Se não for string, converter para string
    //         value = String(value);
    //     }
    
    //     // Remover pontos e converter vírgula para ponto
    //     return parseFloat(value.replace(/\./g, '').replace(',', '.'));
    // };

    const validateForm = () => {
        // console.log('descricao ', descricao);
        // console.log('data ', feriado_data);
        if (!descricao || descricao.trim() === '') {
            closeDock();
            Swal.fire({
                title: 'Atenção',
                text: 'O campo "Descrição" é obrigatório!',
                icon: 'error',
            }).then((result) => {
                if (result.isConfirmed) {
                    openDock();
                }
            });
            return false;
        }
        
        if (!feriado_data || feriado_data.trim() === '') {
            closeDock();
            Swal.fire({
                title: 'Atenção',
                text: 'O campo "Data do Feriado" é obrigatório!',
                icon: 'error',
            }).then((result) => {
                if (result.isConfirmed) {
                    openDock();
                }
            });
            return false;
        }
        return true;
    };
      


    return (
        <div className='container-fluid h-100 pt-4 sidebar p-4'>
            {/* ****** título (novo ou editar feriado) ******** */}
            <h4 className='d-inline'>
                {operacao === 'add' ? 'Adicionar Feriado' : 'Alterar Feriado: id #' + id_feriado}
            </h4>
            <form onSubmit={handleSubmit}>
                {/* ****** campos do serviço ******** */}
                <div className='row tela-card'>
                    <div className='col-12 mt-4'>
                        <p className='text-secundary'>Descrição</p>
                        <div className='form-contrl mb-2'>
                            {/* <input value={operacao === 'edit' ? feriado.DESCRICAO : ''} type="text" className='form-control' */}
                            <input type="text" className='form-control'
                                value={descricao}
                                onChange={(e) => setDescricao(e.target.value.toUpperCase())}  
                            />
                        </div>
                    </div>
                    <div className='col-12 mt-4'>
                        <p className='text-secundary'>Data(dd/mm)</p>
                        <div className='form-contrl mb-2'>
                            <input className='form-control'
                                id="dateInput"
                                type="text"
                                value={feriado_data}
                                onChange={(e) => setFeriado_data(handleTimeInput(e.target.value))}
                                maxLength={5} // Para garantir que não exceda 'hh:mm'
                            />
                        </div>
                    </div>
                </div>            
            </form>

            {/* ****** botões salvar/cancelar ******** */}
            <div className='rwo align-items-end footer'>
                <div className='text-center'>
                    <button className='btn btn-outline-primary me-3'
                        onClick={closeDock}>Cancelar
                    </button>
                    <button type='submit' className='btn btn-primary'
                        onClick={handleSalvarDados}
                    >
                        {operacao === 'add' ? 'Adicionar' : 'Salvar Alterações'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CardFeriado;